(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.headerColor = (document.getElementById('breadcrumb-block-layout')) ? document.getElementById('breadcrumb-block-layout').getAttribute('data-header-color') : 'default';
      this.stickyColorScheme = this.getAttribute('data-sticky-color-scheme');
      if(this.headerColor != 'default'){
        this.classList.add('header-light');
        document.getElementById('MainContent').classList.add('main-header-light');
        this.setAttribute('data-color-scheme', this.stickyColorScheme);
        this.classList.add(this.stickyColorScheme);
        if(this.stickyColorScheme !== this.colorScheme){
          this.classList.remove(this.colorScheme);
        }
      }
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.stickyColorScheme = this.getAttribute('data-sticky-color-scheme');
      this.colorScheme = this.getAttribute('data-color-scheme');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        this.classList.add(this.stickyColorScheme);
        if(this.stickyColorScheme !== this.colorScheme){
          this.classList.remove(this.colorScheme);
        }
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (window.innerWidth >= 1441) {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight * 0.0694444}vw`);
      } else {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const firstSectionHeight = (document.querySelector('main.template--index')) ? Number(document.querySelectorAll('main section.shopify-section')[0].clientHeight - 100) : 100;
      const stickyTriggerPoint = Math.min(window.innerHeight, firstSectionHeight);

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > stickyTriggerPoint) {
        this.header.classList.add('scrolled-past-header');
        this.header.classList.add('animate__fadeInDown');
        this.header.classList.remove('animate__fadeOutUp');
        this.header.classList.add('animate__fadeInDown');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > stickyTriggerPoint) {
        this.header.classList.add('scrolled-past-header');
        this.header.classList.add('animate__fadeInDown');
        this.header.classList.remove('animate__fadeOutUp');
        this.header.classList.add('animate__fadeInDown');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.header.classList.remove('animate__fadeInDown');
        this.header.classList.add('animate__fadeOutUp');
        setTimeout(() => {
          this.header.classList.remove('animate__fadeOutUp');
        }, 400);
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      // this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.header.classList.add('shopify-section-header-sticky');
      this.classList.add(this.stickyColorScheme);
      if(this.stickyColorScheme !== this.colorScheme){
        this.classList.remove(this.colorScheme);
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.classList.add(this.stickyColorScheme);
      if(this.stickyColorScheme !== this.colorScheme){
        this.classList.remove(this.colorScheme);
      }
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if(this.stickyColorScheme !== this.colorScheme){
        this.classList.remove(this.stickyColorScheme);
      }
      this.classList.add(this.colorScheme);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  (function () {
    const header = document.querySelector('.top-sec');
    const headerWrapper = header?.querySelector('.header-wrapper');
    const megaMenu = header?.querySelector('.mega-menu');
    const menuDrawerContainer = document.querySelector('.menu-drawer-container');
    const searchDetails = document.querySelector('details-modal.header__search > details');
    if (!header || !megaMenu || !headerWrapper || !searchDetails) return;

    let interactionTimer;

    const isMegaMenuOpen = () => megaMenu.classList.contains('is-open');
    const isDrawerOpening = () => menuDrawerContainer?.classList.contains('menu-opening');
    const isSearchOpen = () => searchDetails.hasAttribute('open');

    const startInteraction = () => {
      headerWrapper.classList.add('interacted');
      clearTimeout(interactionTimer);
    };

    const endInteraction = () => {
      clearTimeout(interactionTimer);
      interactionTimer = setTimeout(() => {
        if (!isMegaMenuOpen() && !isDrawerOpening() && !isSearchOpen()) {
          if (!header.matches(':hover') && !document.activeElement.closest('.top-sec')) {
            headerWrapper.classList.remove('interacted');
          }
        }
      }, 100);
    };

    // Mouse/touch/keyboard events
    header.addEventListener('mouseenter', startInteraction);
    header.addEventListener('mouseleave', endInteraction);
    header.addEventListener('touchstart', startInteraction, { passive: true });
    header.addEventListener('touchend', endInteraction);
    header.addEventListener('focusin', startInteraction);
    header.addEventListener('focusout', endInteraction);

    // Observe megamenu & drawer state
    const observer = new MutationObserver(() => {
      if (isMegaMenuOpen() || isDrawerOpening() || isSearchOpen()) {
        startInteraction();
      } else {
        endInteraction();
      }
    });

    observer.observe(megaMenu, { attributes: true, attributeFilter: ['class'] });
    if (menuDrawerContainer) {
      observer.observe(menuDrawerContainer, { attributes: true, attributeFilter: ['class'] });
    }
    observer.observe(searchDetails, { attributes: true, attributeFilter: ['open'] });
  })();
  
  } catch(e) { console.error(e); }
})();
})();
